export default "__VITE_ASSET__Bupw_v6j__"